import { SortOrder } from 'antd/es/table/interface';

/**
 * Decile 1 is the weakest bucket, so an unranked store must not be treated as 0 - that ranks it
 * below the weakest, which is the collapse the backend refuses to make. It is off the scale, not at
 * the bottom of it, so it sorts last whichever way the column is sorted.
 *
 * Ant Design negates the comparator's result for a descending sort, so the null branch has to negate
 * with it or the unranked stores swap ends.
 */
export const compareStoreDecile = (
  left?: number | null,
  right?: number | null,
  sortOrder?: SortOrder,
): number => {
  const leftUnranked = left === null || left === undefined;
  const rightUnranked = right === null || right === undefined;

  if (leftUnranked || rightUnranked) {
    if (leftUnranked && rightUnranked) return 0;

    const unrankedLast = leftUnranked ? 1 : -1;
    return sortOrder === 'descend' ? -unrankedLast : unrankedLast;
  }

  return left - right;
};
